import map from "lodash/fp/map";
import first from "lodash/fp/first";
import last from "lodash/fp/last";
import remove from "lodash/fp/remove";
import constants from "../../core/constants";
class Controller {
  constructor($interval, $timeout, $injector, $transitions, GoogleMaps) {
    "ngInject";

    this.$timeout = $timeout;
    this.$interval = $interval;
    this.$transitions = $transitions;

    this.Ride = $injector.get("Ride");
    this.Mapie = $injector.get("Mapie");
    this.Socket = $injector.get("Socket");
    this.Captain = $injector.get("Captain");
    this.RideTransforms = $injector.get("RideTransforms");
    this.CaptainTransforms = $injector.get("CaptainTransforms");

    // This one for ng-map
    this.googleMapsUrl = GoogleMaps.getSource();

    this.applyMapsEvents = (googleMap) => {
      window.google.maps.event.addListener(
        googleMap.infoWindows.carInfoWindow,
        "closeclick",
        () => {
          this.showDirections = false;
          googleMap.setZoom(10);
        }
      );
    };
    this.mapStyle = this.Mapie.getGodsViewStyle();
  }

  $onInit() {
    const _that = this;
    const parseLocation = (location) => {
      const data = {};
      const parsed = location;
      if (parsed) {
        data.location = parsed.location && [
          parsed.location.lat,
          parsed.location.lng,
        ];
        data.bearing = parsed.location && parsed.location.bearing;
        data.ride = parsed.rideId;
        data.captain = parsed.captain;
      }

      return data;
    };
    const formatStations = (station) => {
      const location = {
        lat: last(station.loc.coordinates),
        lng: first(station.loc.coordinates),
      };

      return { location, stopover: true };
    };
    const formatPoints = (station) => {
      const location = [
        last(station.loc.coordinates),
        first(station.loc.coordinates),
      ];

      return Object.assign({}, station, { location, stopover: true });
    };
    const getStringPosition = (origin) =>
      `${origin.location.lat},${origin.location.lng}`;
    const removeLocation = (parsed) => !parsed.location;
    const socket = this.Socket.dashboard();

    this.selected = "activeCaptainsLocation";
    this.onMapInit = (googleMap) => {
      this.map = googleMap;
    };

    socket.on("connect", () => {
      socket.emit("raven:update", {});
    });

    socket.on("raven:update", (data) => {
      this.raven = data.ravenView;

      const initLocations = this.raven[this.selected];
      this.stats = this.raven.status;
      this.stats.total =
        this.stats.inRide + this.stats.offline + this.stats.betweenRide;

      this.$timeout(() => {
        this.carLocations = map(parseLocation)(initLocations);
        this.carLocations = remove(removeLocation)(this.carLocations);
      });
    });

    const checkInterval = this.$interval(() => {
      socket.emit("raven:update", {});
    }, constants.godsViewInterval);

    this.showDetails = function (event, car, markerId) {
      _that.currentRide = null;

      if (car.ride) {
        _that.Ride.get(car.ride).$promise.then((response) => {
          _that.showDirections = false;
          _that.currentRide = _that.RideTransforms.justify(response, true);

          const stations = _that.currentRide.past_stations.concat(
            _that.currentRide.coming_stations
          );
          const formattedStations = map(formatStations)(stations);

          _that.markerPoints = map(formatPoints)(stations);

          const origin = formattedStations.shift();
          const destination = formattedStations.pop();

          _that.currentRouteOrigin = getStringPosition(origin);
          _that.currentRouteDestination = getStringPosition(destination);
          _that.currentRouteWaypoints = formattedStations;

          _that.showDirections = true;
        });
      } else if (car.captain) {
        _that.Captain.get(car.captain.id).$promise.then((response) => {
          _that.currentCaptain = _that.CaptainTransforms.justify(
            response,
            true
          );
        });
      }
      _that.map.showInfoWindow(event, "carInfoWindow", markerId);
      _that.applyMapsEvents(_that.map);
    };

    this.filter = (name) => {
      this.selected = name;
      const locations = this.raven[this.selected];

      this.$timeout(() => {
        this.carLocations = map(parseLocation)(locations);
        this.carLocations = remove(removeLocation)(this.carLocations);
      });
    };

    this.$transitions.onStart({}, () => {
      this.$interval.cancel(checkInterval);
      socket.disconnect();
    });
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/godsViewMap/godsViewMap.controller.js